"use client";

import { useEffect, useRef, useState } from "react";
import mapboxgl from "mapbox-gl";

export default function FacilityMap({
	latitude,
	longitude,
	label,
}: {
	latitude: number;
	longitude: number;
	label: string;
}) {
	const containerRef = useRef<HTMLDivElement>(null);
	const [map, setMap] = useState<mapboxgl.Map | null>(null);

	useEffect(() => {
		if (!containerRef.current) return;

		const m = new mapboxgl.Map({
			container: containerRef.current,
			accessToken: "pk.eyJ1IjoiZWRkeW4iLCJhIjoiY2psY20zY3BhMDIweDNrcjBydTc5NXAyZyJ9.CmVa7hkw9qC7kvkLqeQaXQ",
			style: "mapbox://styles/mapbox/dark-v11",
			center: [longitude, latitude],
			zoom: 14,
			interactive: false,
		});

		new mapboxgl.Marker({ anchor: "center", scale: 1 })
			.setLngLat([longitude, latitude])
			.setPopup(new mapboxgl.Popup({ offset: 25 }).setHTML(label).setMaxWidth("200px"))
			.addTo(m);

		setMap(m);
		return () => m.remove();
	}, [latitude, longitude, label]);

	return <div ref={containerRef} className="w-full h-full" />;
}
